export default __webpack_public_path__ + "img/heating.type.02.asset.bd3df5b3.jpg";